import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import { url } from "../../../../../../../../App";
import Cookies from "js-cookie";
import VoicemailIcon from '@mui/icons-material/Voicemail';
import { useBorrowerContext } from "../../../../../store/borrower-details";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from '@mui/material/TextField';
import { v4 as uuidv4 } from "uuid";
import { TbFileUpload } from "react-icons/tb";
import "./VCIP.css"
import Tooltip from '@mui/material/Tooltip';
import { Modal, Button, Box, Select, MenuItem, FormControl, InputLabel, Chip } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import { IconButton } from '@mui/material';
import { useParams } from 'react-router';
import DeleteIcon from '@mui/icons-material/Delete';
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography
} from "@mui/material";

const CallingCustomer = () => {
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [open, setOpen] = React.useState(false);
  const [customerData, setcustomerData] = useState([]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [userName, setuserName] = useState("");
  const [userMobile, setuserMobile] = useState("");
  const [vendorCalling, setVendorCalling] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [borrowerId, setBorrowerID] = useState("");
  const [visible, setvisible] = useState(false);
  const [UploadAudioVisible, setUploadAudioVisible] = useState(false);
  const [DeleteAudioVisible, setDeleteAudioVisible] = useState(false);
  const [file, setFile] = useState(null);
  const [openCallModal, setOpenCallModal] = useState(false);
  const [callPurpose, setCallPurpose] = useState("");
  const [callingPayloadData, setCallingPayloadData] = useState(null);
  const { borrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData.borrower;
  const coapplicant = borrowerData.coapplicant;
  const coapplicant_IDs = coapplicant.map(coapplicant => coapplicant.coapplicant_id);
  const [rowNumber, setRowNumber] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const { loanid } = useParams();
  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);
  const [isDisbursed, setIsDisbursed] = useState(false);
  console.log(useParams());
  console.log(foundLoan.borrower_uniqueno);
  const [mobileCalled, setMobileCalled] = useState("");
  const [purpose, setPurpose] = useState("");
  const [transcriptionStatus, setTranscriptionStatus] = useState({});
  const [selectedTranscription, setSelectedTranscription] = useState(null);
  const [transcriptionModalOpen, setTranscriptionModalOpen] = useState(false);
  const [transcriptionUUIDs, setTranscriptionUUIDs] = useState([]); 
  const [aiTranscriptionVisible, setAiTranscriptionVisible] = useState(false);

  useEffect(() => {
    if (loanid) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  const paginationViewHandler = (e) => {
    setRowNumber(Number(e.target.value));
    setCurrentPage(1);
  };

  const goToNextPage = () => {
    if (currentPage < totalRecords) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const fetchCustomerData = async (page = currentPage, limit = rowNumber) => {
    setOpen(true);
    try {
      
      const payload = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrower_ID: fetchedBorrowerDetails.borrower_uniqueno,
        coapplicant_ID: coapplicant_IDs,
        reference_ID: fetchedBorrowerDetails.borrower_uniqueno,
        loan_id:loanid
      };

      const [kaleyraRes, knowlarityRes] = await Promise.all([
        axios.post(url + "/customer/getsingle", {
          ...payload, page,
          limit
        }),
        axios.post(url + "/knowlarity/getsingle/api", {
          ...payload, page,
          limit
        }),
      ]);

      const mergedData = [
        ...(kaleyraRes?.data?.listOfCallHistory || []),
        ...(knowlarityRes?.data?.listOfCallHistory || [])
      ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      if (mergedData.length === 0 && page > 1) {
        setCurrentPage(page - 1);
        return;
      }

      console.log("kaleyraRes db-> ", knowlarityRes.data)
      setcustomerData(mergedData);
      setTotalPages(knowlarityRes.data.totalPages+kaleyraRes.data.totalPages);
      setTotalRecords(knowlarityRes.data.totalRecords+kaleyraRes.data.totalRecords);
    } catch (err) {
      console.error("Error fetching customer data:", err);
      toast.error("Failed to fetch customer data.");
    } finally {
      setOpen(false);
    }
  };

  const getTranscription = async (uuid) => {
    console.log('called');
    console.log(uuid);
    try {
      const transcriptionData = await axios.post(`${url}/knowlarity/fetchTranscription`, {
        call_uuid: uuid,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      }
      );

      console.log(transcriptionData.data);

      if (transcriptionData.data.auth) {
        setSelectedTranscription(transcriptionData.data.message.transcription);

        if (transcriptionData.data?.message?.transcription?.dialogue?.length > 0) {
          toast.success("Transcription Fetched");
          setTranscriptionStatus("SUCCESS");
        }
        setTranscriptionModalOpen(true);
      }
    } catch (error) {
      console.error("Failed to get transcription:", error.response?.data || error.message);
      toast.error("Failed to get transcription:", error.response?.data || error.message);
    }
  };

  useEffect(() => {

    const getTranscriptionStatus = async () => {

      try {

        const response = await axios.post(`${url}/knowlarity/transcriptionStatus`, {
            loan_id: loanid,
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
          }
        );

        if (response.data.auth) {

          const uuidList = response.data.message.map(
            (item) => item.call_uuid
          );

          setTranscriptionUUIDs(uuidList);
        }

      } catch (error) {

        console.error("Failed to get transcription status:", error.response?.data || error.message);

      }
    };

    if (loanid) {
      getTranscriptionStatus();
    }

  }, [loanid]);

  useEffect(() => {
    fetchCustomerData(currentPage, rowNumber);
    // eslint-disable-next-line
  }, [currentPage, rowNumber, totalPages, totalRecords]);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          console.log(res);
          console.log(res, "response");
          setuserMobile(res.data[0].staff_mobile);
          setuserName(res.data[0].staff_name);
          setUploadAudioVisible(res.data[0].permission.upload_audio);
          setDeleteAudioVisible(res.data[0].permission.delete_audio);
          setAiTranscriptionVisible(res.data[0].permission?.generate_transcription);
        })
        .catch((err) => {
          console.log(err);
        })
    };

    axios.post(url + '/vendor/view', {
      token: Cookies.get('Token'),
      email: Cookies.get('Email'),
    })
      .then((res) => {
        if (res.data.auth && res.data.message.vendorCalling) {
          console.log(res.data.message)
          setVendorCalling(res.data.message.vendorCalling);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to fetch vendor calling data.");
      });
    fetchCustomerData();
    // eslint-disable-next-line
  }, []);

  const handleRecording = async (referenceNumber, kaleyraId, call_uuid) => {
    setOpen(true);
    try {
      let response;

      if (call_uuid) {
        response = await axios.post(url + "/knowlarity/recording/api", {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          call_uuid,
        });
      } else if (referenceNumber && kaleyraId) {
        response = await axios.post(url + "/customer/recording", {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          referenceNumber,
          kaleyraId,
        });
      } else {
        setOpen(false);
        toast.error("Missing required parameters for fetching recording.");
        return;
      }
      console.log(response.data, "response")
      if (response.data.auth) {
        setOpen(false);
        window.open(response.data.recordingUrl, "_blank");
        toast.success(response.data.message);
        fetchCustomerData();
      } else {
        setOpen(false);
        toast.error(response.data.message);
      }
    } catch (error) {
      setOpen(false);
      console.error("Error fetching recording:", error);
      toast.error("An error occurred while fetching the recording");
    }
  };

  const handleCall = () => {
    if (!mobileNumber.trim()) {
      toast.error("Please enter a mobile number.");
      return;
    }

    if (!/^\d{10}$/.test(mobileNumber)) {
      toast.error("Mobile number must be exactly 10 digits.");
      return;
    }

    const confirmCall = window.confirm("Do you want to call the customer?");
    if (!confirmCall) {
      toast.error("Call cancelled by the user.");
      return;
    }

    if (!vendorCalling) {
      toast.error("Vendor calling info not available.");
      return;
    }

    setCallingPayloadData({
      toNumber: mobileNumber,
      reference_ID: fetchedBorrowerDetails?.borrower_uniqueno,
    });

    setOpenCallModal(true);
  };

  const handleConfirmCall = () => {
    if (!callPurpose) {
      toast.error("Please select call purpose.");
      return;
    }

    if (!callingPayloadData) {
      toast.error("Calling data missing.");
      return;
    }

    setOpen(true);
   
    const payload = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      fromNumber: userMobile,
      toNumber: callingPayloadData.toNumber,
      referenceNumber: uuidv4(),
      customer_Name: userName,
      reference_ID: callingPayloadData.reference_ID,
      call_purpose: callPurpose,
      loan_id:loanid
    };

    let apiEndpoint = "";

    if (vendorCalling === "Knowlarity") {
      apiEndpoint = url + "/knowlarity/call/api";
    } else if (vendorCalling === "Kalerya") {
      apiEndpoint = url + "/customer/call";
    } else {
      setOpen(false);
      toast.error("Invalid vendor calling configuration.");
      return;
    }

    axios
      .post(apiEndpoint, payload)
      .then((res) => {
        setOpen(false);

        if (res.data.auth) {
          toast.success(res.data.message);
          setOpenCallModal(false);
          setCallPurpose("");
          setMobileNumber("");
          fetchCustomerData();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        setOpen(false);
        setMobileNumber("");
        console.error(error);
        toast.error("Failed to initiate call.");
      });
  };

  const handleCallRecording = async () => {
    if (!borrowerId || !mobileCalled || !purpose) {
      toast.error("All fields are required");
      return;
    }
    if (mobileCalled.length !== 10) {
      toast.error("Mobile number should be of 10 digits");
      return;
    }
    setOpen(true);

    // Fetch users details like name and mobile

    let name = '';
    let mobile = '';

    try {
      const email =  Cookies.get("Email");
      const token = Cookies.get("Token");


      const user = await axios.post(url + "/user/getsingle", {
        email,
        token
      });

      console.log(user);
      if (Array.isArray(user.data)) {
        name = user.data[0].staff_name;
        mobile = user.data[0].staff_mobile;
      } else {
        toast.error("Failed to fetch user details");
        setOpen(false);
        return;
      }
    } catch(err) {
      console.error(err);
      toast.error("Issue in fetching user details");
      setOpen(false);
      return;
    }
    const formData = new FormData();
    if (borrowerId.startsWith("CR")){
      formData.append("borrower_ID", borrowerId);
    } else if (borrowerId.startsWith("CA")) {
      formData.append("coapplicant_ID", borrowerId);
      formData.append("borrower_ID", foundLoan.borrower_uniqueno)
    }
    formData.append("file", file);
    formData.append("loan_id", loanid);
    formData.append("customer_Name", name);
    formData.append("agent_number", mobile)
    formData.append("call_purpose", purpose)
    formData.append("customer_number", mobileCalled)


    try {
      const res = await axios.post(url + "/knowlarity/upload/call", formData);
      console.log(res.data);

      if (res.data.auth === true) {
        toast.success(res.data.message);
        setBorrowerID("");
        setMobileCalled("");
        setPurpose("");
        setFile(null);
        setOpenModal(false);
        fetchCustomerData();
      } else {
        toast.error(res.data.message);
      }

    } catch (err) {
      console.error(err);
      toast.error(err);
    } finally {
      setOpen(false);
    }
  };

  const handleDeleteRecording= async (uuid)=>{
  try {
      const res = await axios.post(url + "/knowlarity/delete", {
        token,
        email,
        uuid
      });
      console.log(res.data);

      if (res.data.auth === true) {
        toast.success(res.data.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(res.data.message);
      }

    } catch (err) {
      console.error(err);
      toast.error(err);
    } finally {
      setOpen(false);
    }
  }

  const CALL_PURPOSE_LABEL = {
    TELE_PD: "Tele PD",
    LOAN_VERIFICATION: "Loan Verification",
    REFERENCE_CALL: "Reference Call",
  };

  const handleTranscription = async (uuid) => {
    console.log(uuid, 'uuid');
    try {
      setTranscriptionStatus((prev) => ({
        ...prev,
        [uuid]: "PROCESSING"
      }));

      const response = await axios.post(`${url}/knowlarity/transcription`, { 
        call_uuid: uuid,
        loan_id: loanid,
        customer_id: borrowerId,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      }, { timeout: 0 }
      );

      if (response?.data?.auth) {
        toast.success("Transcription Generated");
        setTranscriptionStatus((prev) => ({
          ...prev,
          [uuid]: "SUCCESS"
        }));

        console.log("Transcription result:", response.data.result);

        // If required, save/display the result here
        // setTranscriptionResult(response.data.result);
      } else {
        toast.error("Transcription generation failed");
        throw new Error("Transcription failed");
      }

    } catch (error) {
      toast.error("Transcription generation failed");
      console.error("Transcription failed:", error.response?.data || error.message);

      setTranscriptionStatus((prev) => ({
        ...prev,
        [uuid]: "FAILED"
      }));
    }
  };

  return (
    <>
      <div style={{ display: "flex", gap: "1rem", marginTop: "1rem", marginBottom: '15px', alignItems: "center" }}>
        <div>
          <TextField
            size="small"
            type="number"
            required
            label="Enter Mobile Number"
            variant="outlined"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            disabled={isDisbursed}
          />
        </div>
        <div>
          <button style={{ fontSize: "12px" }} className="digi-kyc" onClick={handleCall} disabled={isDisbursed}>
            Initiate Call
          </button>
        </div>

        {(UploadAudioVisible || visible) && !isDisbursed && (
          <Tooltip title="Upload Audio Recording">
            <div>
              <TbFileUpload
                size={30}
                style={{ cursor: "pointer" }}
                onClick={() => setOpenModal(true)}
              />
            </div>
          </Tooltip>
        )}

      </div>

      <div className="tableField-view-borrower" style={{
        overflowY: 'scroll',
        overflowX: 'hidden',
        height: "60vh"
      }}>
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: "60vh",
            overflowY: "auto"
          }}
        >
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {[
                  "Staff Name",
                  "To Number",
                  "Call Date",
                  "Call Time",
                  "Call Purpose",
                  "ID",
                  "Call Status",
                  "Call Duration",
                  "Recording",
                  ...((aiTranscriptionVisible || visible)? ["Transcription"] : []),
                  (DeleteAudioVisible || visible) ?  "Action" : ""
                ].map((head) => (
                  <TableCell
                    key={head}
                    align="center"
                    sx={{
                      fontWeight: 600,
                      backgroundColor: "#ced1d8"
                    }}
                  >
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {customerData.map((data, index) => {
                const hasTranscription = transcriptionUUIDs.includes(data?.call_uuid);
                return (
                <TableRow
                  key={index}
                  hover
                  sx={{
                    height: 50  
                  }}
                >
                  <TableCell align="center">{data?.customer_Name}</TableCell>
                  <TableCell align="center">{data?.toNumber ?? data?.customer_number}</TableCell>
                  <TableCell align="center">{data?.callDate ?? data?.call_date}</TableCell>
                  <TableCell align="center">{data?.callTime ?? data?.call_time}</TableCell>
                  <TableCell align="center">
                    {CALL_PURPOSE_LABEL[data?.call_purpose] || "Not Found"}
                  </TableCell>
                  <TableCell align="center">
                    {data?.borrower_ID ||
                      data?.coapplicant_ID ||
                      (data?.reference_ID ? "Reference" : "")}
                  </TableCell>
                  <TableCell align="center">{data?.callStatus ?? data?.call_status}</TableCell>
                  <TableCell align="center">{data?.callStatus === "Connected" || data?.call_status === "Connected"? data?.caller_duration: ""}</TableCell>

                  {/* Recording Icon */}
                  <TableCell align="center">
                    <IconButton
                      onClick={() =>
                        handleRecording(
                          data?.referenceNumber,
                          data?.kaleyraId,
                          data?.call_uuid
                        )
                      }
                    >
                      <VoicemailIcon sx={{ color: "#eb1c24", fontSize: 18 }} />
                    </IconButton>
                  </TableCell>

                  {/* Transcription Icon */}
                  {(aiTranscriptionVisible || visible) &&
                      <TableCell align="center">

                        {(data?.callStatus ?? data?.call_status) === "Connected" && (

                          transcriptionStatus[data?.call_uuid] === "PROCESSING" ? (

                            <Chip
                              label="PROCESSING"
                              size="small"
                              sx={{
                                fontSize: "0.7rem",
                                fontWeight: 700,
                                backgroundColor: "#e8d297",
                                color: "#8a6d1d"
                              }}
                            />

                          ) : hasTranscription ? (

                            <IconButton
                              onClick={() => getTranscription(data?.call_uuid)}
                            >
                              <DescriptionIcon sx={{ color: "#1976d2", fontSize: 20 }} />
                            </IconButton>

                          ) : (

                            <IconButton
                              onClick={() => handleTranscription(data?.call_uuid)}
                            >
                              <AutoAwesomeIcon sx={{ color: "#1976d2", fontSize: 20 }} />
                            </IconButton>

                          )
                        )}

                      </TableCell>
                  }


                  {(DeleteAudioVisible || visible) &&
                    <TableCell align="center">
                      <IconButton
                        onClick={() =>
                          handleDeleteRecording(
                            data?.call_uuid
                          )
                        }
                      >
                        <DeleteIcon sx={{ color: "#eb1c24", fontSize: 18 }} />
                      </IconButton>
                    </TableCell>
                  }
              
                </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>


      </div>
      <div className="Pagination_1" >
        <label>Entries To Display</label>
        <div >
          <TextField
            placeholder="rows"
            select
            name="created-data"
            variant="outlined"
            value={rowNumber}
            size="small"
            onChange={paginationViewHandler}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </TextField>
        </div>
        <div >
          <button
            disabled={currentPage === 1}
            style={{
              padding: "0.5rem",
              color: "white",
              width: "14rem",
              backgroundColor: "blue",
              borderRadius: "2rem",
              px: 4,
              cursor: (currentPage === 1 ? "not-allowed" : "pointer")
            }} onClick={goToPrevPage} >Previous</button>
        </div>
        <span className="pageCount" style={{ textAlign: "center", borderRadius: "2rem", width: "14rem", }}>{currentPage}</span>
        <div >
          <button
            disabled={currentPage === totalPages}
            onClick={goToNextPage}
            style={{
              padding: "0.5rem",
              color: "white",
              width: "14rem",
              backgroundColor: "blue",
              borderRadius: "2rem",
              px: 4,
              cursor: (currentPage === totalPages ? "not-allowed" : "pointer")
            }}>Next</button>
        </div>
      </div>
      {openModal && (
        <div className="modal-overlay-vcip">
          <div className="modal-content-vcip">
            <h2>Upload Audio Recording</h2>

            <div className="form-group-vcip">
              <label>Borrower ID/ Coapplicant ID</label>
              <input
                type="text"
                value={borrowerId}
                onChange={(e) => setBorrowerID(e.target.value)}
                placeholder="Enter Borrower ID/ Coapplicant ID"
              />
            </div>

            <div className="form-group-vcip">
              <label>Mobile Number called</label>
              <input
                type="text"
                value={mobileCalled}
                onChange={(e) => setMobileCalled(e.target.value)}
                placeholder="Enter number called"
              />
            </div>

            <div className="form-group-vcip">
              <label>Purpose</label>
              <select
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  fontSize: "14px",
                  marginTop: "5px",
                  outline: "none",
                  cursor: "pointer",
                  backgroundColor: "#fff"
                }}
              >
                <option value="">Select Purpose</option>
                <option value="TELE_PD">Tele PD</option>
                <option value="LOAN_VERIFICATION">Loan Verification</option>
                <option value="REFERENCE_CALL">Reference Call Up</option>
              </select>
            </div>

            <div className="form-group-vcip">
              <label>Upload Audio</label>
              <input
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>

            <div className="modal-actions-vcip">
              <button
                className="btn-save-vcip"
                onClick={handleCallRecording}
                disabled={!borrowerId || !file}
              >
                Submit
              </button>
              <button
                className="btn-cancel-vcip"
                onClick={() => {
                  setBorrowerID("");
                  setFile(null);
                  setOpenModal(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        open={openCallModal}
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
          }}
        >
          <h3>Select Call Purpose<span style={{ color: "red" }}>*</span></h3>

          <FormControl fullWidth size="small" sx={{ mt: 2 }}>
            <InputLabel>Call Purpose</InputLabel>
            <Select
              value={callPurpose}
              label="Call Purpose"
              onChange={(e) => setCallPurpose(e.target.value)}
            >
              <MenuItem value="TELE_PD">Tele PD</MenuItem>
              <MenuItem value="LOAN_VERIFICATION">Loan Verification</MenuItem>
              <MenuItem value="REFERENCE_CALL">Reference Call</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <Button
              onClick={() => {
                setOpenCallModal(false);
                setCallPurpose("");
                setCallingPayloadData(null);
              }}
              sx={{ mr: 1 }}
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={handleConfirmCall}>
              Call
            </Button>
          </Box>
        </Box>
      </Modal>

      <Dialog
        open={transcriptionModalOpen}
        onClose={() => setTranscriptionModalOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          Call Transcription
        </DialogTitle>

        <DialogContent dividers>

          {selectedTranscription?.dialogue?.map((item, index) => (
            <div
              key={index}
              style={{
                marginBottom: "18px",
                paddingBottom: "12px",
                borderBottom: "1px solid #ddd"
              }}
            >

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "6px"
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 700
                  }}
                >
                  {item?.speaker}
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    color: "#777"
                  }}
                >
                  {item?.timestamp}
                </Typography>
              </div>

              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  marginBottom: "4px"
                }}
              >
                {item?.originalSpokenText}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#555"
                }}
              >
                {item?.englishTranslation}
              </Typography>

            </div>
          ))}

        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setTranscriptionModalOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default CallingCustomer